module.exports = __webpack_public_path__ + "static/media/interface.5aef5fc1.png";